import React from "react";

/** Shared gradient: deep navy -> blue -> cyan, with two soft highlights. */
export const HERO_BG =
  "radial-gradient(circle at 88% 12%, rgba(255,255,255,.14), transparent 42%), " +
  "radial-gradient(circle at 8% 115%, rgba(34,211,238,.25), transparent 45%), " +
  "linear-gradient(135deg, #0c1f45 0%, #1e3a8a 55%, #0e7490 100%)";

interface PageHeroProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  /** Full-width band (home page). Default: rounded card inside a padded page container. */
  bleed?: boolean;
  center?: boolean;
}

export default function PageHero({ eyebrow, title, subtitle, children, bleed = false, center = false }: PageHeroProps) {
  return (
    <section className={`text-white ${bleed ? "relative z-10 w-screen ml-[calc(50%-50vw)]" : "overflow-hidden rounded-xl shadow-sm"}`} style={{ background: HERO_BG }}>
      <div
        className={`${bleed ? "max-w-screen-2xl mx-auto px-4 md:px-8 py-14 md:py-20" : "px-5 md:px-8 py-7 md:py-9"} ${
          center ? "text-center" : ""
        }`}
      >
        {eyebrow && (
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-200 mb-2">{eyebrow}</p>
        )}
        <h1 className={`font-extrabold tracking-tight ${bleed ? "text-4xl md:text-5xl" : "text-3xl md:text-4xl"}`}>{title}</h1>
        {subtitle && (
          <p className={`mt-3 text-brand-100 leading-relaxed ${bleed ? "text-lg max-w-3xl" : "max-w-3xl"} ${center ? "mx-auto" : ""}`}>
            {subtitle}
          </p>
        )}
        {children && <div className="mt-6">{children}</div>}
      </div>
    </section>
  );
}